import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'

// COMPONENTS
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import LogoData from '../components/app-logo/logo-data'
import { ButtonContained } from '../components/app-button/button'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  toolbarInner: {
    padding: 0,
  },
});

class CardFail extends Component {

  state = {
    nextUrl: window.state.nextUrl,
    message: window.state.message,
  }

  render() {
    const { classes } = this.props

    return (
      <div className={classes.pageTemplate}>
        <AppBar
          position="static"
          color="inherit"
          elevation={0}
          style={{ padding: '24px' }}
        >
          <Toolbar className={classes.toolbarInner}>
            <LogoData />
          </Toolbar>
          <div style={{
            display: 'flex',
            width: '100%',
            marginTop: 100,
            flexDirection: 'column',
            alignItems: 'center',
          }}>
            <div>
              <i style={{
                display: 'inline-block',
                width: 60,
                height: 60,
                backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 286.054 286.054\'%3E%3Cpath d=\'M168.352 142.924l25.28-25.28c3.495-3.504 3.495-9.154 0-12.64l-12.64-12.649c-3.495-3.486-9.145-3.495-12.64 0l-25.289 25.289-25.271-25.271c-3.504-3.504-9.163-3.504-12.658-.018l-12.64 12.649c-3.495 3.486-3.486 9.154.018 12.649l25.271 25.271-25.227 25.226a8.93 8.93 0 0 0 0 12.64l12.64 12.649c3.495 3.486 9.145 3.495 12.64 0l25.226-25.226 25.405 25.414c3.504 3.504 9.163 3.504 12.658.009l12.64-12.64c3.495-3.495 3.486-9.154-.009-12.658l-25.404-25.414zM143.027.004C64.031.004 0 64.036 0 143.022c0 78.996 64.031 143.027 143.027 143.027s143.027-64.031 143.027-143.027C286.054 64.045 222.022.004 143.027.004zm0 259.228c-64.183 0-116.209-52.026-116.209-116.209s52.026-116.21 116.209-116.21 116.209 52.026 116.209 116.209-52.026 116.21-116.209 116.21z\' fill=\'%23e2574c\'/%3E%3C/svg%3E")',
                backgroundPosition: '0 0',
                backgroundRepeat: 'no-repeat',
                verticalAlign: 'middle',
              }}></i>
            </div>
            {this.state.message ? (
              <h1>{this.state.message}</h1>
            ) : (
              <h1>Не удалось выполнить платеж</h1>
            )}
            <div>
              <ButtonContained
                href={this.state.nextUrl}
                style={{
                  fontSize: 16,
                  padding: '12px 20px',
                  fontWeight: 700,
                  color: '#000',
                }}
                color="primary"
                text="Продолжить"
              />
            </div>
          </div>
        </AppBar>
      </div>
    )
  }
}

export default withStyles(styles)(CardFail)
